import {plural, t} from "@lingui/core/macro";

import {type LabelsValues} from "@khanacademy/wonder-blocks-dropdown";

export const strings = {
    deleteName: (nickname: string): string => t`Delete ${nickname}`,
    saveChanges: (): string => t`Save changes`,
    numBadges: (badgeCount: number): string =>
        plural(badgeCount, {
            one: "# badge",
            other: "# badges",
        }),
    gradeLevelsAndSubjects: (): string => t`Grade levels and subjects`,
    gradesYouTeach: (): string => t`Grades you teach`,
    subjectsYouTeach: (): string => t`Subjects you teach`,
    collegeAndBeyond: (): string => t`College and beyond`,
    socialStudies: (): string => t`Social studies`,
    worldLanguages: (): string => t`World languages`,
    artsAndHumanities: (): string => t`Arts & Humanities`,
    gradeSelectionPlaceHolder: (): string => t`e.g., 7th grade`,
    subjectSelectionPlaceholder: (): string => t`e.g., Math`,
    subjectsSelected: (numberSelected: number) =>
        plural(numberSelected, {
            one: "# subject",
            other: "# subjects",
        }),
    math: (): string => t`Math`,
    english: (): string => t`English`,
    science: (): string => t`Science`,
    history: (): string => t`History`,
    economics: (): string => t`Economics`,
    computing: (): string => t`Computing`,
    lifeSkills: (): string => t`Life skills`,
    firstGrade: (): string => t`1st grade`,
    secondGrade: (): string => t`2nd grade`,
    thirdGrade: (): string => t`3rd grade`,
    fourthGrade: (): string => t`4th grade`,
    fifthGrade: (): string => t`5th grade`,
    sixthGrade: (): string => t`6th grade`,
    seventhGrade: (): string => t`7th grade`,
    eighthGrade: (): string => t`8th grade`,
    ninthGrade: (): string => t`9th grade`,
    tenthGrade: (): string => t`10th grade`,
    eleventhGrade: (): string => t`11th grade`,
    twelfthGrade: (): string => t`12th grade`,
    allSubjectsSelected: (): string => t`All subjects`,
    clearSearch: (): string => t`Clear search`,
    filter: (): string => t`Filter`,
    noResults: (): string => t`No results`,
    selectAllSubjectLabel: (numOptions: number): string =>
        t`Select all $(numOptions} subjects)`,
    selectAllGradeLevelLabel: (numOptions: number): string =>
        t`Select all $(numOptions} subjects)`,
    selectNoneLabel: (): string => t`Select none`,
    numSubjects: (numOptions: number): string => t`${numOptions} subjects`,
    numGradeLevels: (numOptions: number): string =>
        t`${numOptions} grade levels`,
} as const;

export const getLabels = (
    nonSelectedLabel: string,
    someSelectedLabel: (numSelectedValues: number) => string,
    allSelectedLabel: string,
    selectAllLabel: (numOptions: number) => string,
): LabelsValues => ({
    noneSelected: nonSelectedLabel,
    someSelected: (numSelectedValues: number) =>
        plural(numSelectedValues, {
            other: someSelectedLabel(numSelectedValues),
        }),
    allSelected: allSelectedLabel,
    clearSearch: strings.clearSearch(),
    filter: strings.filter(),
    noResults: strings.noResults(),
    selectAllLabel: (numOptions: number) => selectAllLabel(numOptions),
    selectNoneLabel: strings.selectNoneLabel(),
});
